// styles
import 'antd/dist/antd.less';
import 'assets/styles/index.scss';
import 'assets/styles/AddEditPage.scss';
import 'assets/styles/Authentication.scss';
import 'assets/styles/Dashboard.scss';
import 'assets/styles/DetailPage.scss';
import 'assets/styles/EditClass.scss';
import 'assets/styles/index.scss';
import 'assets/styles/Kanji.scss';
import 'assets/styles/LangSwitcher.scss';
import 'assets/styles/MainHeader.scss';
import 'assets/styles/MainSidebar.scss';
import 'assets/styles/ManagementPage.scss';
import 'assets/styles/Profile.scss';
import 'assets/styles/TableAction.scss';
import 'assets/styles/Policy.scss';
// redux
import { Provider } from 'react-redux';
import store from 'redux/store';
// components
import { ConfigProvider } from 'antd';
import { BrowserRouter } from 'react-router-dom';
import AppRoutes from 'routes';
// multilingual
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';

const App = () => {
    return (
        <I18nextProvider i18n={i18n}>
            <Provider store={store}>
                <ConfigProvider>
                    <BrowserRouter>
                        <AppRoutes />
                    </BrowserRouter>
                </ConfigProvider>
            </Provider>
        </I18nextProvider>
    );
};

export default App;
